{
  "search": "Meklēt",
  "searchWithin": "Meklēt šajā:"
}
